__webpack_require__.p = "/academy/";